class FirehawkCRMStockDetailModal {
	gridItem = null
  container = null

  modalElement = null
  modal = null
  defaultImage = null

	stockSlug = "";
	loginSlug = "";
	cartSlug = "";

  nextId = ""
  prevId = ""
  nextButton = null
  prevButton = null


  addingToCart = false
  allowBackorders = false

  containDisplayImage = false

	constructor(gridItem, options) {
		this.gridItem = gridItem

    if(options.prevId && typeof options.prevId == "string" && options.prevId.length > 0) this.prevId = options.prevId;
    if(options.nextId && typeof options.nextId == "string" && options.nextId.length > 0) this.nextId = options.nextId;

    if (options.container) this.container = options.container
    if (options.defaultImage) this.defaultImage = options.defaultImage
	}

  addListeners() {
    this.modalElement.delegate(".fh-add-to-cart", 'click', (event) => {
      event.preventDefault()
      var current = jQuery(event.currentTarget);
      let stockId = current.data("stock");
      let cartType = current.data("cart-type") || "cart"
      this.addToCart(stockId, current, cartType);
    });

    // this.modalElement.delegate(".close-modal-btn", "click", (event) => {
    //   this.hide()
    // })

    this.modalElement.on('hidden.bs.modal', (event) => {
      if (this.modal) {
        this.modal.dispose()
      }
      if (this.modalElement) {
        this.modalElement.remove()
      }

      this.modal = null
      this.modalElement = null
    })

    this.modalElement.delegate(".quantity-picker .subtract-button", "click", (event) => {
      let quantityField = jQuery(this.modalElement).find(".quantity-picker #quantity")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }
      if (quantity > 1) {
        quantity -= 1
      }

      quantityField.text(quantity)
    })

    this.modalElement.delegate(".quantity-picker .add-button", "click", (event) => {
      let quantityField = jQuery(this.modalElement).find(".quantity-picker #quantity")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }

      quantity += 1
      quantityField.text(quantity)
    })

    var slickopts = {
      slidesToShow: 4,
      slidesToScroll: 4,
      rows: 1,
      accessibility: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        { breakpoint: 610,
          settings: {
            slidesToShow: 3,
            slidesToShow: 3,
            rows: 1
          }
        }
      ]
    };
    var galleryElement =this.modalElement.find("fh-stock-image-gallery"); 
    if(galleryElement.hasClass('slick-initialized')){
     galleryElement.slick('unslick'); 
    }
    galleryElement.slick(slickopts); 
    var gallery = this.modalElement[0]
    lightGallery(gallery, {
      selector: '.gallery-selector',
      addClass: 'stock-detail-modal-gallery',
      share: false,
      download: false,
      pager: false
    })
  }

  buildModal() {

    var availableStock = this.gridItem && this.gridItem._freeStock || 0

    var addToCartButtonLabel = "Add to Shortlist";

    var hasGallery = this.gridItem && this.gridItem.imageGallery && this.gridItem.imageGallery.length;

    let modalContainer = jQuery(`<div class="bs-modal modal fade stock-detail-modal${hasGallery ? ' with-gallery' : ''}" tabindex="-1" id="stock-detail-${this.gridItem.id}" style="display: none;" aria-hidden="true"></div>`)
		let modal = jQuery('<div class="modal-dialog modal-lg modal-dialog-centered"></div>')
		let modalContent = jQuery('<div class="modal-content">')

    
    const modalPrevious = document.createElement("div") 
    modalPrevious.className ="modal-previous"
    if(this.prevId){
      modalPrevious.innerHTML = '<i class="fas fa-chevron-left"></i>'
      this.prevButton = modalPrevious
    }
    
    const modalNext = document.createElement("div") 
    modalNext.className ="modal-next"
    if(this.nextId){
      modalNext.innerHTML = '<i class="fas fa-chevron-right"></i>'
      this.nextButton = modalNext
    }
    // Setup: Modal body
		let modalBody = jQuery('<div class="modal-body"></div>')
    
    const closeElement = document.createElement("div") 
    closeElement.className ="modal-close"

    closeElement.innerHTML = '<i class="far fa-times" aria-hidden="true"></i>'
    closeElement.addEventListener("click", () => {
      this.hide();
    })

    modalContent.append(closeElement)

    // Setup: Stock display image
    var displayImage = this.gridItem.displayImage || this.defaultImage


    var imageColumn = jQuery(`<div class="col-12 col-lg-6 image-col"></div>`)
		if (displayImage && displayImage.length) {
			imageColumn.append(`<div class="display-image image-basic gallery-selector${this.containDisplayImage ? ' contain-image': ''}" style="background-image: url('${displayImage}')" data-src="${displayImage}"></div>`)
      
      if (this.gridItem && this.gridItem.imageGallery && this.gridItem.imageGallery.length) {
        let imageGallery = jQuery('<div class="fh-stock-image-gallery"></div>')
        for (let galleryItem of this.gridItem.imageGallery) {
          imageGallery.append(`<div class="gallery-item gallery-selector" data-src="${galleryItem.downloadUrl}">
            <div class="inner">
              <a style="background-image: url('${galleryItem.downloadUrl}')">
                <img style="display: none;" src="${galleryItem.downloadUrl}"></img>
              </a>
            </div>
          </div>`)
        }
        imageColumn.append(imageGallery)
      }
		} else {
			imageColumn.append('<div class="display-image placeholder image-basic" style="background: #f1f1f1;"></div>')
		}

    modalBody.append(imageColumn)

    // Setup: Stock info
    let stockInfo = jQuery('<div class="col-12 col-lg-6 stock-info-col"></div>')
    stockInfo.append(`<h4 class="stock-title mb-0">${this.gridItem.name}</h4>`)
    if (this.gridItem.stockCode) {
      stockInfo.append(`<p class="stock-code">${this.gridItem.stockCode}</p>`)
    }

    if (this.gridItem.description) {
      stockInfo.append(`<p class="stock-description">${this.gridItem.description}</p>`)
    }


    let footer = jQuery('<div class="footer"></div>')

    if (this.gridItem.price) {
      footer.append(`<div class="stock-price"><span>Price:</span><span>${this.gridItem.price}</span></div>`)
    }
    let footerActions = jQuery('<div class="footer-actions"></div>')
    	    // footerActions.append(`<div class="input-group quantity-picker">
	    //   <button class="btn btn-primary subtract-button input-group-prepend" type="button">-</button>
	    //   <label class="form-control text-center" aria-label="Quantity" id="quantity">1</label>
	    //   <button class="btn btn-primary add-button input-group-append" type="button">+</button>
	    // </div>`)

    
    footerActions.append(`<button type="button" class="btn btn-primary fh-add-to-cart" data-stock="${this.gridItem.id}">${addToCartButtonLabel}</button>`)

		
    footer.append(footerActions)
    stockInfo.append(footer)

    modalBody.append(stockInfo)
		modalContent.append(modalPrevious)
    modalContent.append(modalBody)
		modalContent.append(modalNext)

		modal.append(modalContent)
		modalContainer.append(modal)
		return modalContainer
  }

  show() {
    if (!this.gridItem) return;

    let modalElement = jQuery(this.buildModal())

    if (this.container) {
      jQuery(this.container).append(modalElement)
    } else {
      jQuery("body").append(modalElement)
    }

    this.modalElement = modalElement
		this.modal = new bootstrap.Modal(modalElement.get(0), {})
		this.modal.show()

    this.addListeners()
  }

  hide() {
    this.modal.hide()
  }

  addToCart(stock, currentTarget, cartType) {
    if (this.addingToCart) return;
    this.addingToCart = true

    jQuery(currentTarget).addClass("loading")

    let quantityField = jQuery(this.modalElement).find(".quantity-picker #quantity")
    var quantity = quantityField.text() || 1

    var params = {
      stock: stock,
      quantity: quantity
    };

    jQuery.ajax({
      method: 'post',
      url: ajax_var.url,
      data: {
        action: 'add_to_cart',
        params: params
      }
    }).done((response) => {
      if (jQuery(this.modalElement).find(".cart-success").length == 0) {

        jQuery(`<div class="bd-callout bd-callout-success cart-success">Item added to favourites. <a href="/${this.cartSlug}">View Shortlist</a></div>`).prependTo(jQuery(this.modalElement).find(".stock-info-col .footer"))
        
      }
    }).fail(() => {

    }).always(() => {
      jQuery(currentTarget).removeClass("loading")
      this.addingToCart = false
    })

  }
}
